import type { StateWithSinatra } from '../types';

export const selectUser = (state: StateWithSinatra) => state.sinatra.user;
export const selectIsLoggedIn = (state: StateWithSinatra) =>
  state.sinatra.user.isLoggedIn;
export const selectApplication = (state: StateWithSinatra) =>
  state.sinatra.user.currentRole?.application;
